import React, { useState, useEffect } from 'react';
import "./Timer.css";
//TODO: Split out the timer logic into util functions, create separate views for reservationtimer and launchtimer
//TODO: allow passing in of styles instead of relying on stylesheets

function Timer({ duration, expireReservation, timerType="reservation"}) {
  const [remaining, setRemaining] = useState(duration);
  useEffect(() => {
    if (remaining <= 0) {
      expireReservation()
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [remaining]);

  useEffect(() => {
    setRemaining(Math.round(duration));
  }, [duration])

  useEffect(() => {
    const timerIntervalId = setInterval(() => {
      setRemaining(t => t - 1)
    }, 1000);
    return () => {
      clearInterval(timerIntervalId);
    }
  }, [])

  const day = Math.floor(remaining / (3600*24));
  const hour = Math.floor(remaining / 3600) - (day * 24);
  const min = Math.floor(remaining / 60) - (day * 24 * 60) - (hour * 60);
  const sec = remaining - (day * 24 * 3600) - (hour * 3600) - (min*60);

  const dayFormatted = `${day.toString().padStart(2, '0')}`;
  const hourFormatted = `${hour.toString().padStart(2, '0')}`;
  const minFormatted = `${min.toString().padStart(2, '0')}`;
  const secFormatted = `${sec.toString().padStart(2, '0')}`;

  
  if (timerType === "reservation") {
    let formattedRemaining = `${minFormatted}:${secFormatted}`;
    return (
      <div>
        <p id="time-remaining" className="is-size-1 has-text-centered">{formattedRemaining || "0:00"}</p>
      </div>
    )
  }

  if (timerType === "launchCountdown") {
    return (
      <div id="launch-countdown" className="columns">
        <div className="column is-1 is-offset-4">
          <p className="value">{dayFormatted}</p>
          <p className="unit">days</p>
        </div>
        <div className="column is-1">
          <p className="value">{hourFormatted}</p>
          <p className="unit" >hours</p>
        </div>
        <div className="column is-1">
          <p className="value">{minFormatted}</p>
          <p className="unit">mins</p>
        </div>
        <div className="column is-1">
          <p className="value">{secFormatted}</p>
          <p className="unit">secs</p>
        </div>
      </div>
    )
  }
  
 
}

export default Timer;